import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map } from 'rxjs/operators';

/**
 * Guard qui empêche les utilisateurs authentifiés d'accéder aux pages publiques (login, register, etc.)
 * Redirige vers la page d'accueil si déjà authentifié
 */
export const noAuthGuard: CanActivateFn = () => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  return oidcSecurityService.isAuthenticated$.pipe(
    map(({ isAuthenticated }) => {
      if (isAuthenticated) {
        // Déjà authentifié, redirige vers l'accueil
        router.navigate(['/']);
        return false;
      }
      // Non authentifié, peut accéder à la page de login
      return true;
    }),
  );
};
